import { LocalAssignmentJuneCtrl } from './local-assignment-june.controller';

export const LocalAssignmentJuneComponent = {
  controller: LocalAssignmentJuneCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./local-assignment-june.html'),
};
